// START GENAI@CHATGPT4
import { Component, Prop, State, h, Event, EventEmitter, Fragment } from '@stencil/core';

@Component({
  tag: 'vs-quiz-countdown',
  styleUrls: {
    default: './vs-quiz-countdown.css',
  },
  shadow: false,
})
export class VsQuizCountdown {
  /**
   * @shortDescription Start Time of the countdown
   * @controlName quizTime
   */
  @Prop() quizTime: string;

  @State() seconds: number = null;
  @State() minutes: number = null;
  @State() hours: number = null;
  @State() isTimesUp: boolean = false;
  @State() countDownIntervalId: any;

  @State() displayTime: string = '';

  /**
   * @shortDescription Emit times up event
   * @controlName timesUpEvent */
  @Event({
    eventName: 'timesUpEvent',
    composed: true,
    cancelable: true,
    bubbles: true,
  }) onTimesUpEvent: EventEmitter;


  componentWillLoad(): void {
    this.initCounter(this.quizTime);
    this.startCountDown();
  }

  initCounter(quizTime: string): void {
    if (quizTime) {
      const splitTime = quizTime.split(':');
      this.hours = parseInt(splitTime[0]);
      this.minutes = parseInt(splitTime[1]);
      this.seconds = parseInt(splitTime[2]);
      this.isTimesUp = false;
    }
  }

  startCountDown(): void {
    this.countDownIntervalId = setInterval(() => {
      this.decrementTime();
      if (!this.isTimesUp) {
        this.checkTimesUp();
      }
    }, 1000);
  }

  decrementTime(): void {
    if (this.seconds === 0) {
      if (this.minutes === 0) {
        if (this.hours > 0) {
          this.hours--;
          this.minutes = 59;
        }
      } else {
        this.minutes--;
        this.seconds = 59;
      }
    } else {
      this.seconds--;
    }
  }

  checkTimesUp(): void {
    this.displayTime = this.processDisplayTime();
    if (this.hours === 0 && this.minutes === 0 && this.seconds === 0) {
      this.isTimesUp = true;
      this.onTimesUpEvent.emit(true);
    }
  }

  processDisplayTime(): string {
    return this.setNumToTwoDigits(this.hours) + ':' + this.setNumToTwoDigits(this.minutes) + ':' + this.setNumToTwoDigits(this.seconds);
  }

  setNumToTwoDigits(value): string {
    if (value || value == 0) {
      if (value.toString().length <= 1) {
        return '0' + value.toString();
      }
      return value.toString();
    } else {
      return value;
    }
  }


  disconnectedCallback(): void {
    clearInterval(this.countDownIntervalId);
  }

  render() {
    return (
      <Fragment>
        {
          this.hours !== null && this.minutes !== null && this.seconds !== null &&
          <div class='vs-d-flex vs-justify-content-end'>
            <div class='vs-quiz-border vs-h3 vs-quiz-heading'>
              {this.displayTime}
            </div>
          </div>
        }
      </Fragment>
    );
  }
}

// END GENAI@CHATGPT4
